/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseSupervisorPhotoUrlResponseData } from './genericApiResponseSupervisorPhotoUrlResponseData';
import type { GenericApiResponseSupervisorPhotoUrlResponseMessage } from './genericApiResponseSupervisorPhotoUrlResponseMessage';
import type { GenericApiResponseSupervisorPhotoUrlResponsePagination } from './genericApiResponseSupervisorPhotoUrlResponsePagination';
import type { GenericApiResponseSupervisorPhotoUrlResponseError } from './genericApiResponseSupervisorPhotoUrlResponseError';

export interface GenericApiResponseSupervisorPhotoUrlResponse {
  data?: GenericApiResponseSupervisorPhotoUrlResponseData;
  message?: GenericApiResponseSupervisorPhotoUrlResponseMessage;
  pagination?: GenericApiResponseSupervisorPhotoUrlResponsePagination;
  error?: GenericApiResponseSupervisorPhotoUrlResponseError;
  statusCode?: number;
}
